import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';


const DonorsDelay = (props) => {

  const axiosinterval = useRef(0);

  const [state, setState] = useState({
    donors: [],
    interval: 15000
  })

  useEffect(() => {
    getData();
    return () => clearInterval(axiosinterval.current);
  }, [])

  const getData = () => {
    const config = {
      headers: { Authorization: `Bearer f6aae0c02a0bbc778f806f41685ccde2258a4e0b52821e1aed699b620fc39494` }
    };

    axios.get(
      `https://tiltify.com/api/v3/campaigns/140395/donations?count=30`,
      config
    ).then(res => {
      const donors = res.data.data;
      setState((prev) => {
        return {
          ...prev,
          donors: donors
        }
      });

      const calcSpeed2 = speed => {
        // Time = Distance/Speed
        let spanSelector = document.querySelectorAll(
          ".marquee-wrap .scroller2"
        ),
          i;
        for (i = 0; i < spanSelector.length; i++) {
          const spanLength = spanSelector[i].offsetWidth,
            timeTaken = spanLength / speed;
          spanSelector[i].style.animationDuration = timeTaken + "s";
          setState((prev) => {
            return {
              ...prev,
              interval: (timeTaken * 1000)
            }
          });
          axiosinterval.current = setTimeout(getData, state.interval);
        }
      };
      calcSpeed2(40);

    })

  }

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const textColor = urlParams.get('textColor');

  const addZeroes = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || (res[1].length <= 3)) {
      value = value.toFixed(2).replace(/\.00$/, "");
    }
    return value
  }

  return (
    <div className="donor-list">
      <div className="fade-left"></div>
      <div className="fade-right"></div>
      <div className="marquee-wrap">
        <div className="scroller2">

          <ul id="donors">
            <li className="recent-dono">Recent Donations</li>
            {state.donors.slice().reverse().map(donation => (
              <li key={donation.id}>
                <strong>{donation.name}</strong>{" "}
                <span className={`
                      donation-amount
                      ${textColor}`}>${addZeroes(donation.amount)}</span>{" "}
              </li>
            ))}
          </ul>

        </div>

      </div>

    </div>
  );
}

export default DonorsDelay;
